import React from 'react';
import ButtonComponent from '../../../../../components/Buttons/ButtonComponent';
import Grid from '@mui/material/Grid';
import CustomizeButtonComponent from '../../../../../components/Buttons/CustomizeButtonComponent';

const ButtonTemporaryReceipt = ({
    isApprove,
    isUnApprove,
    ReloadData,
    DataRegUserAccess,
    AddTR,
    AddNewDP,
    isDisabled,
    EditTR,
    DeleteData,
    Print,
    RePrint,
    handleApprove,
    HandleStatus,
    DropDownTitle,
    DropDownList,
    UnApprove,
    Approve,
    handleUnApprove
}) => {

    const renderButton = (data) => {
        switch (data.accessCode) {
            case 'CRE':
                return (
                    <>
                        {ButtonComponent.AddButton(AddTR, 'New', false, isDisabled)}
                        {ButtonComponent.AddButton(AddNewDP, 'New DP', false, isDisabled)}
                    </>
                );
            case 'REI':
                return ButtonComponent.EditButton(EditTR, 'Data');
            case 'DEL':
                return DropDownTitle !== 'Deleted' ? ButtonComponent.DeleteButton(DeleteData, 'Data', false) : null;
            case 'PRI':
                return DropDownTitle !== 'Deleted' ? ButtonComponent.PrintButton(Print) : null;
            case 'RPR':
                return DropDownTitle !== 'Deleted' ? ButtonComponent.ReprintButton(RePrint, 'Approval') : null;
            case 'APP':
                return (DropDownTitle === 'All' || DropDownTitle === 'Active') ? ButtonComponent.ApproveButton(handleApprove, 'Approve') : null;
            case 'UPP':
                return (DropDownTitle === 'All' || DropDownTitle === 'Posted') ? ButtonComponent.UnApproveButton(handleUnApprove, 'Un-Approve') : null;

            default:
                return null;
        }
    };

    return (
        <div className="row">
            <div className='col-12'>
                <Grid container item spacing={1} direction="row" style={{ maxWidth: '100vw', margin: '0px', columnGap: '8px', rowGap: '10px' }}>
                    {isApprove === false && isUnApprove === false ? (
                        <>
                            {ButtonComponent.ReloadButton(ReloadData)}

                            {DataRegUserAccess.map(data => (
                                <React.Fragment key={data.accessId}>
                                    {renderButton(data)}
                                </React.Fragment>
                            ))}

                            {CustomizeButtonComponent.DropDownButtonStatus(HandleStatus, DropDownTitle, DropDownList)}
                        </>
                    ) : isApprove ? (
                        <>
                            {ButtonComponent.BackButton(handleApprove)}
                            {ButtonComponent.ReloadButton(ReloadData)}

                            {DataRegUserAccess.map(data => (
                                data.accessCode === 'APP' && (
                                    <React.Fragment key={data.accessId}>
                                        {ButtonComponent.ApproveButton(Approve, 'Approve Data')}
                                    </React.Fragment>
                                )
                            ))}
                        </>
                    ) : (
                        <>
                            {ButtonComponent.BackButton(handleUnApprove)}
                            {ButtonComponent.ReloadButton(ReloadData)}

                            {DataRegUserAccess.map(data => (
                                data.accessCode === 'UPP' && (
                                    <React.Fragment key={data.accessId}>
                                        {ButtonComponent.UnApproveButton(UnApprove, 'Un Approve Data')}
                                    </React.Fragment>
                                )
                            ))}
                        </>
                    )}
                </Grid>
            </div>
        </div>
    );
};

export default ButtonTemporaryReceipt;